export default __webpack_public_path__ + "1e4a1cf49373b8d5405258c0ad65aa43.png";